import {Box, Grid, Link, Typography} from "@mui/material";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {fontType} from "../../constants/font";
import softec from "../../assets/success_stories/softec-logo.png";
import telegrafia from "../../assets/success_stories/telegrafia_white_logo.png";
import csob from "../../assets/success_stories/csob-logo.png";
import React from "react";

const SuccessStoriesComponent = () => {
    const [ref, inView] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });
    const [products, inViewProducts] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    return (
        <Box
            sx={{
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    maxWidth: "1440px",
                    width: "100%",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "relative",
                }}
            >
                <motion.div
                    ref={ref}
                    initial={{ opacity: 0, y: 50 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                    transition={{ duration: 0.7 }}
                >
                    <Typography
                        sx={{
                            fontFamily: fontType.regular,
                            fontSize: 55,
                            color: "#1b144a",
                            textAlign: "center",
                            marginTop: {sm: "67px", xs: "47px"},
                            lineHeight: {sm: "54px", xs: "74px"},
                            zIndex: 2,
                            maxWidth: "622px",
                            paddingLeft: { xs: "10px", sm: "0px" },
                            paddingRight: { xs: "10px", sm: "0px" },
                        }}
                    >
                        <span style={{color: "#f6961d"}}>Success</span> Stories
                    </Typography>
                </motion.div>
                <Box
                    sx={{
                        marginTop: {sm: "77px", xs: "57px"},
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        zIndex: 2,
                    }}
                >
                    <motion.div
                        ref={products}
                        initial={{ opacity: 0, y: 50 }}
                        animate={
                            inViewProducts ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }
                        }
                        transition={{ duration: 0.7 }}
                    >
                        <Grid
                            container
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "100px",
                                maxWidth: "1500px",
                                paddingLeft: { xs: "10px", sm: "0px" },
                                paddingRight: { xs: "10px", sm: "0px" },
                                marginBottom: { sm: "125px", xs: "70px" },
                            }}
                        >
                            <Box
                                item
                                sx={{
                                    backgroundColor: "#1b144a",
                                    height: {md: "470px", xs: "unset"},
                                    width: { sm: "403px", xs: "100%" },
                                    maxWidth: { sm: "unset", xs: "370px" },
                                    borderRadius: "22px",
                                    transform: "scale(1)",
                                    transition: "transform 0.3s ease",
                                    "&:hover": {
                                        // Styles on hover
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        margin: "20px",
                                        marginBottom: "40px",
                                        marginTop: "40px",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={telegrafia}
                                        alt="telegrafia"
                                        style={{maxWidth: "300px"}}
                                    />
                                </Box>
                                <Box sx={{ paddingTop: "15px" }}>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.regular,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginRight: "30px",
                                        }}
                                    >
                                        Pre AAS Solutions sme sa rozhodli na základe pozitívnych referencií a odborného zamerania vašich školení.<br />
                                        Oslovila nás kombinácia praktických skúseností lektorov a aktuálnych tém priamo prepojených s praxou v technických a vývojových tímoch.
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.semiBold,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginTop: "87px",
                                            marginBottom: {md: "0", xs: "30px"}
                                        }}
                                    >
                                        <Link
                                            href="/success_story/telegrafia"
                                            sx={{
                                                color: "white",
                                                textDecorationColor: "white",
                                            }}
                                        >
                                            Čítať viac >
                                        </Link>
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                item
                                sx={{
                                    backgroundColor: "#1b144a",
                                    height: {md: "470px", xs: "unset"},
                                    width: { sm: "403px", xs: "100%" },
                                    maxWidth: { sm: "unset", xs: "370px" },
                                    borderRadius: "22px",
                                    transform: "scale(1)",
                                    transition: "transform 0.3s ease",
                                    "&:hover": {
                                        // Styles on hover
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        margin: "20px",
                                        marginBottom: "40px",
                                        marginTop: "40px",
                                        textAlign: "center"
                                    }}
                                >
                                    <img
                                        src={softec}
                                        alt="softec"
                                        style={{maxWidth: "300px"}}
                                    />
                                </Box>
                                <Box sx={{ paddingTop: "15px"}}>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.regular,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginRight: "30px",
                                        }}
                                    >
                                        Pod vedením spoločnosti AAS Solutions ďalší z členov nášho testerského tímu v SOFTECu úspešne absolvovali školenie ISTQB Foundation Level.<br />
                                        Vzdelávanie v oblasti testovania je pre nás dlhodobou prioritou – snažíme sa dopĺňať vedomosti našim novším aj skúsenejším kolegom a zároveň štandardizovať testerské know-how naprieč tímom.
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.semiBold,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginTop: "47px",
                                            marginBottom: {md: "0", xs: "30px"}
                                        }}
                                    >
                                        <Link
                                            href="/success_story/softec"
                                            sx={{
                                                color: "white",
                                                textDecorationColor: "white",
                                            }}
                                        >
                                            Čítať viac >
                                        </Link>
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                item
                                sx={{
                                    backgroundColor: "#1b144a",
                                    height: {md: "470px", xs: "unset"},
                                    width: { sm: "403px", xs: "100%" },
                                    maxWidth: { sm: "unset", xs: "370px" },
                                    borderRadius: "22px",
                                    transform: "scale(1)",
                                    transition: "transform 0.3s ease",
                                    "&:hover": {
                                        // Styles on hover
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        margin: "20px",
                                        marginBottom: "40px",
                                        marginTop: "40px",
                                        textAlign: "center"
                                    }}
                                >
                                    <img
                                        src={csob}
                                        alt="csob"
                                        style={{maxWidth: "200px"}}
                                    />
                                </Box>
                                <Box sx={{ paddingTop: "15px"}}>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.regular,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginRight: "30px",
                                        }}
                                    >
                                        Školenie od AAS sme si vybrali ako prípravný kurz na certifikáciu ISTQB pre testerov na základe odporúčania.<br />
                                        Naším cieľom bolo zvýšiť pripravenosť kolegov na samotnú certifikačnú skúšku.
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontFamily: fontType.semiBold,
                                            fontSize: 18,
                                            lineHeight: "22px",
                                            color: "white",
                                            marginLeft: "30px",
                                            marginTop: "92px",
                                            marginBottom: {md: "0", xs: "30px"}
                                        }}
                                    >
                                        <Link
                                            href="/success_story/csob"
                                            sx={{
                                                color: "white",
                                                textDecorationColor: "white",
                                            }}
                                        >
                                            Čítať viac >
                                        </Link>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </motion.div>
                </Box>
            </Box>
        </Box>
    );
};

export default SuccessStoriesComponent;
